import axiosInstance from "../../interceptor/axiosInstance";
import { INTERNAL_USERS } from "../../routes/routeConstants/apiRoutes";
import { deserialize } from "serializr";
import { PaginationModel } from "../../models/PaginationModel/pagination.model";
import Notification from "../../shared/components/Notification";
import { NotificationTypes } from "../../enums/notificationTypes";
import { InternalUserModel } from "../../models/InternalUserModel/internalUser.model";

export default class InternalUserService {
  static getInternalUsersList(
    queryParams: String,
    onSuccess: Function,
    onError: Function,
    onFinal: () => void
  ) {
    return axiosInstance
      .get(INTERNAL_USERS + queryParams)
      .then((response) => {
        const internalUsers = deserialize(
          InternalUserModel,
          response.data["managers"]
        );
        const pageMeta = deserialize(PaginationModel, response.data["meta"]);
        onSuccess(internalUsers, pageMeta);
      })
      .catch((error) => {
        onError(error);
      })
      .finally(onFinal);
  }

  static createInternalUser(
    data: any,
    onSuccess: Function,
    onError: Function,
    onFinal: () => void
  ) {
    return axiosInstance
      .post(INTERNAL_USERS, data)
      .then((response) => {
        const internalUser = deserialize(
          InternalUserModel,
          response.data["manager"]
        );
        onSuccess(internalUser);
      })
      .catch((error) => {
        console.log(new Error(error));
        Notification({
          message: "Error",
          description: error?.response?.data?.error,
          type: NotificationTypes.ERROR,
        });
        onError(error);
      })
      .finally(onFinal);
  }

  static updateInternalUser(
    id: String,
    data: any,
    onSuccess: Function,
    onError: Function,
    onFinal: () => void
  ) {
    return axiosInstance
      .put(INTERNAL_USERS + `/${id}`, data)
      .then((response) => {
        const internalUser = deserialize(
          InternalUserModel,
          response.data["manager"]
        );
        onSuccess(internalUser);
      })
      .catch((error) => {
        Notification({
          message: "Error",
          description: "Unable to update",
          type: NotificationTypes.ERROR,
        });
        onError(error);
      })
      .finally(onFinal);
  }

  static deleteInternalUser(
    id: String,
    onSuccess: Function,
    onError: Function,
    onFinal: () => void
  ) {
    return axiosInstance
      .delete(INTERNAL_USERS + `/${id}`)
      .then(() => {
        onSuccess();
      })
      .catch((error) => {
        Notification({
          message: "Error",
          description: "Unable to delete",
          type: NotificationTypes.ERROR,
        });
        onError(error);
      })
      .finally(onFinal);
  }
}
